<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
  >
    <template #INVENTORY="{ row }">
      <Button
        type="success"
        size="small"
        @click="openDetail(row, 'Inventory')"
        >{{ row.already_listed_number }}</Button
      >
    </template>
    <template #PICK="{ row }">
      <Button type="success" size="small" @click="openDetail(row, 'pick')">{{
        row.freeze_quantity
      }}</Button>
    </template>
    <template #OUTBOUNDRECORD="{ row }">
      <Button
        type="success"
        size="small"
        @click="openDetail(row, 'Outboundrecord')"
        >{{ row.outbound_quantity }}</Button
      >
    </template>
  </cTable>
</template>

<script>
import {
  getStock,
  getShelvesLog,
  getPickupLog,
  getOutLog,
} from "@/api/storage/stock";
import cTable from "@/base/common/index.vue";
import { getAllClient } from "@/api/user/client";
import { getWarehouse } from "@/api/storage/warehouse";
export default {
  name: "stock",
  components: {
    cTable,
  },
  async created() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "warehouse_id")
        item.options = (
          await getWarehouse({ is_storage: "YES" })
        ).data.payload.rows;
    });
  },
  methods: {
    // 查看详情
    openDetail(row, str) {
      let table = this.$refs["table"];
      let obj = {
        sku_id: row.sku_id,
        page: 1,
        pageSize: 15,
      };
      // table.handleRequestMethods(str, obj).then(res => {
      // this.detailList = res.payload;
      table.getModal(str).setTitle(this.$t(str));
      table.getModal(str).open({}, function () {
        this.pageConfig.data = { sku_id: row.sku_id };
        this.getList();
      });
      // });
    },
  },
  data() {
    return {
      methods: {
        list: getStock,
        Inventory: getShelvesLog,
        pick: getPickupLog,
        Outboundrecord: getOutLog,
      },
      modals: {
        Inventory: {
          config: {
            listFn: "Inventory",
            modalBind: {
              width: "80%",
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          btns: {
            list: [
              {
                name: () => this.$t("export"),
                type: "export",
                fnName: "export",
                size: "small",
                disabled() {
                  return !this.selectAll.length;
                },
                bind: {
                  icon: "md-arrow-down",
                  type: "primary",
                },
              },
            ],
            methods: {
              export() {
                this.$page.exportExc({
                  data: this.list,
                  fields: this.table.fields,
                  name: this.title,
                });
              },
            },
          },
          table: {
            footer: {
              show: true,
            },
            config: {
              align: "center",
              height: 400,
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                width: 60,
              },
              {
                name: () => this.$t("operation") + this.$t("time"),
                key: "location_time",
                align: "center",

                minWidth: 200,
              },
              {
                name: () => this.$t("warehouseName1"),
                key: "warehouse_name",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("location"),
                key: "location",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("skuName1"),
                key: "sku_name",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("SKU"),
                key: "bar_code",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("supplier"),
                key: "account",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("noofpieces"),
                key: "number",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("operation") + this.$t("type"),
                key: "direction",
                align: "center",
                minWidth: 95,
                methods: {
                  render({ row }) {
                    return row.direction ? this.$t("down") : this.$t("up");
                  },
                },
              },
            ],
          },
        },
        pick: {
          config: {
            listFn: "pick",
            modalBind: {
              width: "80%",
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          btns: {
            list: [
              {
                name: () => this.$t("export"),
                type: "export",
                fnName: "export",
                size: "small",
                disabled() {
                  return !this.selectAll.length;
                },
                bind: {
                  icon: "md-arrow-down",
                  type: "primary",
                },
              },
            ],
            methods: {
              export() {
                this.$page.exportExc({
                  data: this.list,
                  fields: this.table.fields,
                  name: this.title,
                });
              },
            },
          },
          table: {
            footer: {
              show: true,
            },
            config: {
              align: "center",
              height: 400,
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                width: 60,
              },
              {
                name: () => this.$t("placeOrder") + this.$t("time"),
                key: "create_time",
                align: "center",

                minWidth: 200,
              },
              {
                name: () => this.$t("outboundTime"),
                key: "send_time",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("inboundTime"),
                key: "airway_number",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("skuName1"),
                key: "sku_name",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("barCode"),
                key: "bar_code",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("price_t"),
                key: "declaration_amount",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("invoicePCS"),
                key: "pickup_number",
                align: "center",

                minWidth: 95,
              },
            ],
          },
        },
        Outboundrecord: {
          config: {
            listFn: "Outboundrecord",
            modalBind: {
              width: "80%",
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          btns: {
            list: [
              {
                name: () => this.$t("export"),
                type: "export",
                fnName: "export",
                size: "small",
                disabled() {
                  return !this.selectAll.length;
                },
                bind: {
                  icon: "md-arrow-down",
                  type: "primary",
                },
              },
            ],
            methods: {
              export() {
                this.$page.exportExc({
                  data: this.list,
                  fields: this.table.fields,
                  name: this.title,
                });
              },
            },
          },
          table: {
            footer: {
              show: true,
            },
            config: {
              align: "center",
              height: 400,
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                width: 60,
              },
              {
                name: () => this.$t("placeOrder") + this.$t("time"),
                key: "create_time",
                align: "center",

                minWidth: 180,
              },
              {
                name: () => this.$t("out") + this.$t("time"),
                key: "send_time",
                align: "center",

                minWidth: 180,
              },
              {
                name: () => this.$t("OutOrderNum"),
                key: "airway_number",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("skuName1"),
                key: "sku_name",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("barCode"),
                key: "bar_code",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("price_t"),
                key: "declaration_amount",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("invoicePCS"),
                key: "pickup_number",
                align: "center",

                minWidth: 95,
              },
              {
                name: () => this.$t("备注"),
                key: "remarks",
                align: "center",

                minWidth: 95,
              },
            ],
          },
        },
      },
      header: {
        searchs: [
          {
            key: "warehouse_id",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName1");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
            methods: {
              'on-query-change': () => {

              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "success",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            export({ row }) {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("warehouseName1"),
          key: "warehouse_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("supplier"),
          key: "account",
          minWidth: 100,
        },
        {
          name: () => this.$t("skuName1"),
          key: "sku_name",
          align: "left",

          minWidth: 100,
        },
        {
          name: () => this.$t("skuTitle"),
          key: "sku_title",
          align: "left",
          tooltip: true,
          minWidth: 125,
        },
        {
          name: () => this.$t("SKU Barcode"),
          key: "bar_code",
          align: "left",
          copy: true,
          header: {
            copy: true,
          },
          minWidth: 150,
        },
        {
          name: () => this.$t("already_listed_number"),
          key: "already_listed_number",
          align: "center",

          minWidth: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    //   disabled: params.row.outbound_quantity > 0 ? false : true
                  },
                  on: {
                    click: () => {
                      let table = this.$refs["table"];
                      table.getModal("Inventory").open({}, function () {
                        this.setTitle(
                          params.row.bar_code +
                            this.$t("Inventory") +
                            this.$t("operationLog")
                        );
                        this.pageConfig.data = {
                          sku_id: params.row.sku_id,
                          warehouse_id: params.row.warehouse_id,
                        };
                        this.getList();
                      });
                    },
                  },
                },
                params.row.already_listed_number
              ),
            ]);
          },
        },
        {
          name: () => this.$t("not_listed_number"),
          key: "not_listed_number",
          align: "center",

          minWidth: 100,
        },
        {
          name: () => this.$t("use_quantity"),
          key: "use_quantity",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("freeze_quantity"),
          key: "freeze_quantity",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    //   disabled: params.row.outbound_quantity > 0 ? false : true
                  },
                  on: {
                    click: () => {
                      let table = this.$refs["table"];
                      table.getModal("pick").open({}, function () {
                        this.setTitle(
                          params.row.bar_code + this.$t("freeze_quantity")
                        );
                        this.pageConfig.data = {
                          sku_id: params.row.sku_id,
                          warehouse_id: params.row.warehouse_id,
                        };
                        this.getList();
                      });
                    },
                  },
                },
                params.row.freeze_quantity
              ),
            ]);
          },
        },
        {
          name: () => this.$t("outbound_quantity"),
          key: "outbound_quantity",
          align: "center",

          minWidth: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    //   disabled: params.row.outbound_quantity > 0 ? false : true
                  },
                  on: {
                    click: () => {
                      let table = this.$refs["table"];
                      table.getModal("Outboundrecord").open({}, function () {
                        this.setTitle(
                          params.row.bar_code +
                            this.$t("Outboundrecord") +
                            this.$t("operationLog")
                        );
                        this.pageConfig.data = {
                          sku_id: params.row.sku_id,
                          warehouse_id: params.row.warehouse_id,
                        };
                        this.getList();
                      });
                    },
                  },
                },
                params.row.outbound_quantity
              ),
            ]);
          },
        },
      ],
    };
  },
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
